import React from "react";
import { Modal, Form } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useEnableUserMutation } from "../../../../../redux/apiSlice";

const SuspendUserModal = ({ showEnableSocialUserModal, onHide, details }) => {
  const [
    enableUser, // This is the mutation trigger
    
  ] = useEnableUserMutation()

  const onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    enableUser({
      profileId: details?.profileId
    })
      .unwrap()
      .then(() => {
        cogoToast.success("Created 'Enable User' Action Successfully")
        onHide()
      })
  }


  return (
    <Modal
      show={showEnableSocialUserModal}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
    > <Form
      noValidate
      onSubmit={onSubmit}
    >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Enable User
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
            <span aria-hidden="true" className="d-block">×</span>
            <span className="sr-only">Close</span>
          </button>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
          <p>{`Are you sure you want to enable this user`}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate px-4"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary btn-elevate px-4 ml-4"
          >
            Enable
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SuspendUserModal;